export default "__VITE_ASSET__BxlWPHO$__"